/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Inline_LabelInputs */

const en_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Inline`)
};

const fr_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer en ligne`)
};

const de_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inline einfügen`)
};

const it_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci in linea`)
};

const ru_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить встроенный текст`)
};

const es_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar en línea`)
};

const zh_cn2_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入内联`)
};

const ja_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インライン挿入`)
};

const hi_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इनलाइन डालें`)
};

const pt_pt2_insert_speaker_inline_label = /** @type {(inputs: Insert_Speaker_Inline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir em linha`)
};

/**
* | output |
* | --- |
* | "Insert Inline" |
*
* @param {Insert_Speaker_Inline_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_inline_label = /** @type {((inputs?: Insert_Speaker_Inline_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Inline_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_inline_label(inputs)
	if (locale === "de") return de_insert_speaker_inline_label(inputs)
	if (locale === "it") return it_insert_speaker_inline_label(inputs)
	if (locale === "ru") return ru_insert_speaker_inline_label(inputs)
	if (locale === "es") return es_insert_speaker_inline_label(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_inline_label(inputs)
	if (locale === "ja") return ja_insert_speaker_inline_label(inputs)
	if (locale === "hi") return hi_insert_speaker_inline_label(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_inline_label(inputs)
	return en_insert_speaker_inline_label(inputs)
});